import React, { useState } from "react";
import SideBar from "../components/common/SideBar";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import Notifications from "../components/common/Notifications";
import Scheduled from "../components/ScheduledDraft/Scheduled";
import UserAccountModal from "../components/common/UserAccountModal";
import useUserEmail from "../utils/useUserEmail";
import useLinkedInAccounts from "../utils/useLinkedInAccounts";

const Draft = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);

  const email = useUserEmail();
  const { accounts } = useLinkedInAccounts(email);

  return (
    <div className="flex flex-col min-h-screen bg-black-0">
      <Navbar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        onOpenAccountModal={() => setIsAccountModalOpen(true)}
      />
      <div className="flex flex-1">
        <SideBar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <main className="flex-1 p-6 space-y-6 overflow-hidden md:ml-[125px]">
          <div className="border border-gradient-04 rounded-2xl overflow-hidden">
            {email && <Scheduled email={email} accounts={accounts} />}
          </div>
        </main>
      </div>
      <Footer />
      {/* <Notifications /> */}
      <UserAccountModal
        isOpen={isAccountModalOpen}
        onClose={() => setIsAccountModalOpen(false)}
        userName=""
        setUserName={() => {}}
        userEmail={email}
      />
    </div>
  );
};

export default Draft;